import { createReducer } from '@topconagriculture/frontend-utils';

import { createLocation, deleteLocation, editLocation, getLocationsList } from './locations.actions';
import { FarmerLocation } from './locations.types';

export type LocationState = FarmerLocation[];

const initialState: LocationState = [];

const inventoryReducer = createReducer(initialState, {
  [getLocationsList.done.type]: (state: LocationState, action: ReturnType<typeof getLocationsList.done>) =>
    action.payload.result,
  [createLocation.done.type]: (state: LocationState, action: ReturnType<typeof createLocation.done>) => {
    const newLocations = [...state];
    newLocations.push(action.payload.result);
    return newLocations;
  },
  [editLocation.done.type]: (state: LocationState, action: ReturnType<typeof editLocation.done>) => {
    const editedLocation = action.payload.result;
    const newLocations = state.map((location) => (location.id === editedLocation.id ? editedLocation : location));
    return newLocations;
  },
  [deleteLocation.done.type]: (state: LocationState, action: ReturnType<typeof deleteLocation.done>) => {
    const id = action.payload.params;
    const newLocations = state.filter((location) => location.id !== id);
    return newLocations;
  },
});

export default inventoryReducer;
